import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex gap-4 items-center" }
const _hoisted_2 = { class: "text-lg text-gray-800" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" 실행 ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_card = _resolveComponent("a-card")!

  return (_openBlock(), _createBlock(_component_a_card, null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.uploadMediaTypeKorean) + " 시나리오 ", 1),
        _createVNode(_component_a_select, {
          value: _ctx.selectedScenario,
          "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedScenario) = $event)),
          class: "flex-1",
          size: "large",
          options: _ctx.scenarioList
        }, null, 8, ["value", "options"]),
        _createVNode(_component_a_button, {
          type: "primary",
          style: {"min-width":"80px"},
          disabled: _ctx.disabled,
          onClick: _ctx.onClick
        }, {
          default: _withCtx(() => [
            _hoisted_3
          ]),
          _: 1
        }, 8, ["disabled", "onClick"])
      ])
    ]),
    _: 1
  }))
}